/** @module root/components/accreditation/master-doc-list */
import * as STATES                      from './master-doc-list.states';
import { IDS }                          from './master-doc-list-action-id.constants';

import { masterDocList }                from './master-doc-list.component'
import { masterDocListGrid }            from './master-doc-list-grid.component'
import { masterDocListDetails }         from './details/master-doc-list-details.component'
import { masterDocListRequirementsGrid }from './details/master-doc-list-requirements-grid.component'
import { masterDocListExport }          from './export/master-doc-list-export.component'


export const MASTER_DOC_LIST_MODULE = angular.module(
    'migration.accreditation.master-doc-list',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
    Object.values(STATES).map(
        state => stateRegistry.register(state)
    );
}]).component({
    masterDocList,
    masterDocListGrid,
    masterDocListDetails,
    masterDocListRequirementsGrid,
    masterDocListExport,

}).run(['$templateCache', ({ put }) => {
    put( IDS.app_accreditation_scheme_master_doc_list_list,     '<master-doc-list></master-doc-list>' );
    put( IDS.app_accreditation_scheme_master_doc_list_details,  '<master-doc-list-details></master-doc-list-details>' );
    put( IDS.app_accreditation_scheme_master_doc_list_export,      '<master-doc-list-export></master-doc-list-export>' );

    // put('./master-doc-list-grid-filter.html', require('./master-doc-list-grid-filter.html'));
    // put('./master-doc-list-grid-filter-controls.html', require('./master-doc-list-grid-filter-controls.html'));
}]);
